export const STOCK_ERROR = 'Product variants not available.';
